import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import React from "react";

import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { cookies } from "./axios/axios.jsx";
import WhatsAppButton from "./Components/WhatsAppButton";

import Home from "./pages/Home";
import Testimonial from "./pages/Testimonial";
import CompareSlider from "./Components/home/CompareSlider";
import ContactUs from "./pages/ContactUs";
import ColorCorrection from "./pages/services/ColorCorrection.jsx";
import Retouching from "./pages/services/Retouching.jsx";
import VideoEditing from "./pages/services/VideoEditing.jsx";
import AlbumEditing from "./pages/services/AlbumEditing.jsx";
import RealEstate from "./pages/services/RealEstate.jsx";
import Login from "./pages/Login.jsx";
import Signup from "./pages/SignUp.jsx";
import Profile from "./Components/Dashboard/Profile.jsx";
import ColorCorrectionOrder from "./Components/Dashboard/ColorCorrectionOrder.jsx";
import AlbumDesignOrder from "./Components/Dashboard/AlbumDesignOrder.jsx";
import VideoEditingOrder from "./Components/Dashboard/VideoEditingOrder.jsx";
import RetouchingOrder from "./Components/Dashboard/RetouchingOrder.jsx";
import CullingOrder from "./Components/Dashboard/CullingOrder.jsx";
import RealEstateOrder from "./Components/Dashboard/RealEstateOrder.jsx";
import DashboardPage from "./Components/Dashboard/DashboardPage.jsx";
import ColorCorrectionForm from "./pages/ColorCorrectionForm.jsx";
import RealEstateForm from "./pages/RealEstateForm.jsx";
import AlbumDesignForm from "./pages/AlbumDesignForm.jsx";
import CullingForm from "./pages/CullingForm.jsx";
import RetouchingForm from "./pages/RetouchingForm.jsx";
import VideoEditingForm from "./pages/VideoEditingForm.jsx";
import UploadPage from "./pages/UploadPage.jsx";
import Dashboard from "./pages/OrderManager/Dashboard.jsx";
import RealEstateManager from "./pages/OrderManager/RealEstateManager.jsx";
import RetouchingManager from "./pages/OrderManager/RetouchingManager.jsx";
import VideoEditingManager from "./pages/OrderManager/VideoEditingManager.jsx";
import ColorCorrectionManager from "./pages/OrderManager/ColorCorrectionManager.jsx";
import WeddingAlbumManager from "./pages/OrderManager/WeddingAlbumManager.jsx";
import CullingManager from "./pages/OrderManager/CullingManager.jsx";
import RealEstateManagerDetail from "./pages/OrderManager/RealEstateManagerDetail.jsx";
import RetouchingManagerDetail from "./pages/OrderManager/RetouchingDetailManager.jsx";
import ColorCorrectionDetailManager from "./pages/OrderManager/ColorCorrectionDetailManager.jsx";
import VideoEditingDetailManager from "./pages/OrderManager/VideoEditingDetailManager.jsx";
import WeddingAlbumManagerDetail from "./pages/OrderManager/WeddingAlbumManagerDetail.jsx";
import CullingManagerDetail from "./pages/OrderManager/CullingManagerDetail.jsx";
import FreeTrial from "./pages/freeTrial/FreeTrial.jsx";
import AddServices from "./pages/admin/AddServices.jsx";
import UserTable from "./pages/admin/UserTable.jsx";
import AdminDashboard from "./pages/admin/AdminDashboard.jsx";
import UserOrders from "./pages/admin/UserOrders.jsx";
import UserDetailAdmin from "./pages/admin/UserDetailAdmin.jsx";
import AllTrials from "./pages/admin/AllTrials.jsx";
import CouponForm from "./pages/admin/CouponForm.jsx";
import AdminCoupons from "./pages/admin/AdminCoupons.jsx";
import UploadBanner from "./pages/admin/UploadBanner.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import VerifyEmailOtp from "./pages/VerifyMailOtp.jsx";
import RealEstateEditor from "./pages/editor-dashboard/RealEstateEditor.jsx";
import RealEstateEditorDetail from "./pages/editor-dashboard/RealEstateEditorDetail.jsx";
import ColorCorrectionEditor from "./pages/editor-dashboard/ColorCorrectionEditor.jsx";
import ColorCorrectionEditorDetail from "./pages/editor-dashboard/ColorCorrectionEditorDetail.jsx";
import RetouchingEditorDetail from "./pages/editor-dashboard/RetouchingEditorDetail.jsx";
import WeddingAlbumEditorDetail from "./pages/editor-dashboard/WeddingAlbumEditorDetail.jsx";
import VideoEditingEditorDetail from "./pages/editor-dashboard/VideoEditingEditorDetail.jsx";
import CullingEditorDetail from "./pages/editor-dashboard/CullingEditorDetail.jsx";
import RetouchingEditor from "./pages/editor-dashboard/RetouchingEditor.jsx";
import WeddingAlbumEditor from "./pages/editor-dashboard/WeddingAlbumEditor.jsx";
import VideoEditingEditor from "./pages/editor-dashboard/VideoEditingEditor.jsx";
import CullingEditor from "./pages/editor-dashboard/CullingEditor.jsx";
import BlogPages from "./pages/blogs/Blogs.jsx";
import AddBlogs from "./pages/admin/AddBlogs.jsx";
import SingleBlogPage from "./pages/blogs/SingleBlogPage.jsx";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy.jsx";
import Faqs from "./Components/home/Faqs.jsx";
import AllServices from "./pages/admin/AllServices.jsx";
import AllBlogs from "./pages/admin/AllBlogs.jsx";
import WhyChooseUs from "./pages/choose-us/WhyChooseUs.jsx";

const user = cookies.get("user");

function FreeTrialRedirect() {
  const [alertShown, setAlertShown] = React.useState(false);
  React.useEffect(() => {
    if (!alertShown) {
      alert(
        "You will get a free trial when your account is approved by admin."
      );
      setAlertShown(true);
    }
  }, [alertShown]);
  return null;
}

function AccessDeniedRedirect() {
  const [alertShown, setAlertShown] = React.useState(false);
  React.useEffect(() => {
    if (!alertShown) {
      alert(
        "You cannot access the dashboard or orders until your account is approved by admin."
      );
      setAlertShown(true);
    }
  }, [alertShown]);
  return null;
}

function App() {
  return (
    <>
      <WhatsAppButton />
      <Routes>
      <Route path="/" Component={Home} />
      <Route path="/login" Component={Login} />
      <Route path="/why-us" Component={WhyChooseUs} />
      <Route path="/signup" Component={Signup} />
      <Route path="/privacy-policy" Component={PrivacyPolicy} />
      <Route path="/faqs" Component={Faqs} />
      <Route path="/blogs" Component={BlogPages} />
      <Route path="/blog/:id" Component={SingleBlogPage} />
      <Route path="/forgot-password" Component={ForgotPassword} />
      <Route path="/reset-password" Component={ResetPassword} />
      <Route path="/verify-otp" Component={VerifyEmailOtp} />
      <Route path="/testimonial" Component={Testimonial} />
      <Route path="/slider" Component={CompareSlider} />
      <Route path="/contact-us" Component={ContactUs} />
      <Route path="/color-correction" Component={ColorCorrection} />
      <Route path="/retouching" Component={Retouching} />
      <Route path="/video-editing" Component={VideoEditing} />
      <Route path="/album-editing" Component={AlbumEditing} />
      <Route path="/real-estate" Component={RealEstate} />
      {/* free Trial */}
      {user ? (
        user?.user?.status === "active" ? (
          <Route path="/free-trial" Component={FreeTrial} />
        ) : (
          <Route path="/free-trial" Component={FreeTrialRedirect} />
        )
      ) : (
        <Route path="/free-trial" element={<Navigate to="/login" />} />
      )}
      {/* forms */}
      {user ? (
        user?.user?.status === "active" ? (
          <>
            <Route
              path="/colorcorrection-form/:id"
              Component={ColorCorrectionForm}
            />
            <Route path="/culling-form/:id" Component={CullingForm} />
            <Route path="/retouching-form/:id" Component={RetouchingForm} />
            <Route path="/realestate-form/:id" Component={RealEstateForm} />
            <Route path="/albumdesign-form/:id" Component={AlbumDesignForm} />
            <Route path="/videoediting-form/:id" Component={VideoEditingForm} />
            <Route path="/upload-files/:id" Component={UploadPage} />
          </>
        ) : (
          <>
            <Route
              path="/colorcorrection-form/:id"
              Component={FreeTrialRedirect}
            />
            <Route path="/culling-form/:id" Component={FreeTrialRedirect} />
            <Route path="/retouching-form/:id" Component={FreeTrialRedirect} />
            <Route path="/realestate-form/:id" Component={FreeTrialRedirect} />
            <Route path="/albumdesign-form/:id" Component={FreeTrialRedirect} />
            <Route
              path="/videoediting-form/:id"
              Component={FreeTrialRedirect}
            />
            <Route path="/upload-files/:id" Component={FreeTrialRedirect} />
          </>
        )
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      {/* user dashboard */}
      {user ? (
        user?.user?.status === "active" ? (
          <>
            <Route path="/user-dashboard" Component={DashboardPage} />
            <Route path="/profile" Component={Profile} />
          </>
        ) : (
          <>
            <Route path="/user-dashboard" Component={AccessDeniedRedirect} />
            <Route path="/profile" Component={AccessDeniedRedirect} />
          </>
        )
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      {/* order routes */}
      {user ? (
        user?.user?.status === "active" ? (
          <>
            <Route
              path="/colorcorrection-order"
              Component={ColorCorrectionOrder}
            />
            <Route path="/realestate-order" Component={RealEstateOrder} />
            <Route path="/albumdesign-order" Component={AlbumDesignOrder} />
            <Route path="/videoediting-order" Component={VideoEditingOrder} />
            <Route path="/retouching-order" Component={RetouchingOrder} />
            <Route path="/culling-order" Component={CullingOrder} />
          </>
        ) : (
          <>
            <Route
              path="/colorcorrection-order"
              Component={AccessDeniedRedirect}
            />
            <Route path="/realestate-order" Component={AccessDeniedRedirect} />
            <Route path="/albumdesign-order" Component={AccessDeniedRedirect} />
            <Route
              path="/videoediting-order"
              Component={AccessDeniedRedirect}
            />
            <Route path="/retouching-order" Component={AccessDeniedRedirect} />
            <Route path="/culling-order" Component={AccessDeniedRedirect} />
          </>
        )
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}

      {/* admin panel */}
      {user?.user?.role === "admin" ? (
        <>
          <Route path="/add-services" Component={AddServices} />
          <Route path="/all-services" Component={AllServices} />
          <Route path="/user-table" Component={UserTable} />
          <Route path="/admin-dashboard" Component={AdminDashboard} />
          <Route path="/user-orders-admin" Component={UserOrders} />
          <Route path="/user-detail-admin/:id" Component={UserDetailAdmin} />
          <Route path="/user-trials" Component={AllTrials} />
          <Route path="/admin-coupon" Component={AdminCoupons} />
          <Route path="/coupon" Component={CouponForm} />
          <Route path="/upload-banner" Component={UploadBanner} />
          <Route path="/add-blogs" Component={AddBlogs} />
          <Route path="/all-blogs" Component={AllBlogs} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      {/* Editor Dashboard */}
      {user?.user?.role === "editor" ? (
        <>
          <Route path="/realestate-editor" Component={RealEstateEditor} />
          <Route path="/retouching-editor" Component={RetouchingEditor} />
          <Route path="/weddingalbum-editor" Component={WeddingAlbumEditor} />
          <Route path="/videoediting-editor" Component={VideoEditingEditor} />
          <Route path="/culling-editor" Component={CullingEditor} />
          <Route
            path="/colorcorrection-editor"
            Component={ColorCorrectionEditor}
          />
          <Route
            path="/realestate-editor-detail/:id"
            Component={RealEstateEditorDetail}
          />
          <Route
            path="/colorcorrection-editor-detail/:id"
            Component={ColorCorrectionEditorDetail}
          />
          <Route
            path="/retouching-editor-detail/:id"
            Component={RetouchingEditorDetail}
          />
          <Route
            path="/weddingalbum-editor-detail/:id"
            Component={WeddingAlbumEditorDetail}
          />
          <Route
            path="/videoediting-editor-detail/:id"
            Component={VideoEditingEditorDetail}
          />

          <Route
            path="/culling-editor-detail/:id"
            Component={CullingEditorDetail}
          />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      {/*  Manager Dashboard*/}
      {user?.user?.role === "manager" ? (
        <>
          <Route path="/order-manager-dashboard" Component={Dashboard} />
          <Route path="/realestate-manager" Component={RealEstateManager} />
          <Route path="/retouching-manager" Component={RetouchingManager} />
          <Route path="/videoediting-manager" Component={VideoEditingManager} />
          <Route path="/weddingalbum-manager" Component={WeddingAlbumManager} />
          <Route path="/culling-manager" Component={CullingManager} />
          <Route
            path="/colorcorrection-manager"
            Component={ColorCorrectionManager}
          />
          <Route
            path="/realestate-detail-manager/:id"
            Component={RealEstateManagerDetail}
          />
          <Route
            path="/retouching-detail-manager/:id"
            Component={RetouchingManagerDetail}
          />{" "}
          <Route
            path="/colorcorrection-detail-manager/:id"
            Component={ColorCorrectionDetailManager}
          />{" "}
          <Route
            path="/videoediting-detail-manager/:id"
            Component={VideoEditingDetailManager}
          />{" "}
          <Route
            path="/weddingalbum-detail-manager/:id"
            Component={WeddingAlbumManagerDetail}
          />{" "}
          <Route
            path="/culling-detail-manager/:id"
            Component={CullingManagerDetail}
          />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/login" />} />
      )}
      <Route
        path="/*"
        element={
          <h1 className="text-center mt-5">
            <b>404</b> Page Not Found
          </h1>
        }
      />
      </Routes>
    </>
  );
}

export default App;
